export default __webpack_public_path__ + "static/media/Visa.341f7b66.svg";